import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useAuth } from '../../../features/auth/auth-context';
import { CrmTelegramConnectPanel } from '../../../features/crm/components/crm-telegram-connect-panel';

export const Route = createFileRoute('/_authenticated/crm/telegram')({
  staticData: { breadcrumb: 'Telegram' },
  component: TelegramPage,
});

function TelegramPage() {
  const { adminRoles } = useAuth();
  const allowed =
    adminRoles.includes('SUPERADMIN') ||
    adminRoles.includes('CITY_MODERATOR') ||
    adminRoles.includes('CRM_MANAGER');
  if (!allowed) {
    return <Navigate to="/crm/conversations" />;
  }
  return <CrmTelegramConnectPanel />;
}
